/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Join_Thousands_Of_Thrifters_AInputs */

const en_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join thousands of thrifters, artists, and entrepreneurs building businesses on their own terms.`)
};

const es_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a miles de vendedores, artistas y emprendedores que construyen negocios bajo sus propios términos.`)
};

const fr_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoignez des milliers de chineurs, artistes et entrepreneurs qui bâtissent des entreprises selon leurs propres termes.`)
};

const de_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließe dich Tausenden von Second-Hand-Verkäufern, Künstlern und Unternehmern an, die Geschäfte zu ihren eigenen Bedingungen aufbauen.`)
};

const ja_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分自身のルールでビジネスを築いている何千人もの古着屋、アーティスト、起業家の仲間入りをしましょう。`)
};

const zh_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入成千上万在自己规则下建立业务的旧货商、艺术家和企业家的行列。`)
};

const ar_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انضم إلى الآلاف من البائعين، الفنانين، ورواد الأعمال الذين يبنون أعمالهم بشروطهم الخاصة.`)
};

const id_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabunglah dengan ribuan pelaku thrifting, seniman, dan pengusaha yang membangun bisnis dengan cara mereka sendiri.`)
};

const it_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisciti a migliaia di venditori di usato, artisti e imprenditori che costruiscono business alle proprie condizioni.`)
};

const ru_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присоединяйтесь к тысячам продавцов, художников и предпринимателей, строящих бизнес на собственных условиях.`)
};

const pt_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junte-se a milhares de vendedores de brechó, artistas e empreendedores que constroem negócios em seus próprios termos.`)
};

const ko_join_thousands_of_thrifters_a = /** @type {(inputs: Join_Thousands_Of_Thrifters_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자신만의 방식으로 비즈니스를 구축하고 있는 수천 명의 리셀러, 아티스트, 기업가들과 함께하세요.`)
};

/**
* | output |
* | --- |
* | "Join thousands of thrifters, artists, and entrepreneurs building businesses on their own terms." |
*
* @param {Join_Thousands_Of_Thrifters_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const join_thousands_of_thrifters_a = /** @type {((inputs?: Join_Thousands_Of_Thrifters_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Join_Thousands_Of_Thrifters_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_join_thousands_of_thrifters_a(inputs)
	if (locale === "es") return es_join_thousands_of_thrifters_a(inputs)
	if (locale === "fr") return fr_join_thousands_of_thrifters_a(inputs)
	if (locale === "de") return de_join_thousands_of_thrifters_a(inputs)
	if (locale === "ja") return ja_join_thousands_of_thrifters_a(inputs)
	if (locale === "zh") return zh_join_thousands_of_thrifters_a(inputs)
	if (locale === "ar") return ar_join_thousands_of_thrifters_a(inputs)
	if (locale === "id") return id_join_thousands_of_thrifters_a(inputs)
	if (locale === "it") return it_join_thousands_of_thrifters_a(inputs)
	if (locale === "ru") return ru_join_thousands_of_thrifters_a(inputs)
	if (locale === "pt") return pt_join_thousands_of_thrifters_a(inputs)
	return ko_join_thousands_of_thrifters_a(inputs)
});